// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MemosTable_MemoFragment = { __typename?: 'Memo', id: string, name: string, createdAt: Time, updatedAt: Time, entryMode?: Types.MemoEntryMode | null, memoPrompt?: { __typename?: 'MemoPrompt', id: string, memoPromptType: Types.MemoPromptMemoPromptType, name: string } | null, user: { __typename?: 'User', id: string, displayName: string }, updateUser: { __typename?: 'User', id: string, displayName: string } };

export type MemosTableMemosQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  searchValue?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type MemosTableMemosQuery = { __typename?: 'Query', memos: { __typename?: 'MemoConnection', edges?: Array<{ __typename?: 'MemoEdge', node?: (
        { __typename?: 'Memo' }
        & MemosTable_MemoFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    MemosTableMemos: 'MemosTableMemos' as const
  },
  Fragment: {
    MemosTable_Memo: 'MemosTable_Memo' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const MemosTable_MemoFragmentDoc = gql`
    fragment MemosTable_Memo on Memo {
  id
  name
  createdAt
  updatedAt
  entryMode
  memoPrompt {
    id
    memoPromptType
    name
  }
  user {
    id
    displayName
  }
  updateUser {
    id
    displayName
  }
}
    `;
export const MemosTableMemosDocument = gql`
    query MemosTableMemos($householdId: ID!, $searchValue: String) {
  memos(
    where: {hasHouseholdWith: [{id: $householdId}], nameContainsFold: $searchValue}
    orderBy: [{field: updated_at, direction: DESC}]
  ) {
    edges {
      node {
        ...MemosTable_Memo
      }
    }
  }
}
    ${MemosTable_MemoFragmentDoc}`;

/**
 * __useMemosTableMemosQuery__
 *
 * To run a query within a React component, call `useMemosTableMemosQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemosTableMemosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemosTableMemosQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      searchValue: // value for 'searchValue'
 *   },
 * });
 */
export function useMemosTableMemosQuery(baseOptions: Apollo.QueryHookOptions<MemosTableMemosQuery, MemosTableMemosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemosTableMemosQuery, MemosTableMemosQueryVariables>(MemosTableMemosDocument, withFetchPolicyContext(options));
      }
export function useMemosTableMemosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemosTableMemosQuery, MemosTableMemosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemosTableMemosQuery, MemosTableMemosQueryVariables>(MemosTableMemosDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useMemosTableMemosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MemosTableMemosQuery, MemosTableMemosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemosTableMemosQuery, MemosTableMemosQueryVariables>(MemosTableMemosDocument, withFetchPolicyContext(options));
        }
export type MemosTableMemosQueryHookResult = ReturnType<typeof useMemosTableMemosQuery>;
export type MemosTableMemosLazyQueryHookResult = ReturnType<typeof useMemosTableMemosLazyQuery>;
export type MemosTableMemosSuspenseQueryHookResult = ReturnType<typeof useMemosTableMemosSuspenseQuery>;
export type MemosTableMemosQueryResult = Apollo.QueryResult<MemosTableMemosQuery, MemosTableMemosQueryVariables>;